// extracted by mini-css-extract-plugin
module.exports = {"content":"MPz9I5n61ksU4wIReAW0G"};